__turbopack_context__.v({
  "heading": "AuthorsList-module-scss-module__Rz50XG__heading",
  "list": "AuthorsList-module-scss-module__Rz50XG__list",
  "wrapper": "AuthorsList-module-scss-module__Rz50XG__wrapper",
});
